import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';

enum MaterialTypes {
  Dry = 1,
  Liquid = 2,
  Cement = 3,
  LiquidBase = 4,
  Pozolan = 5,
  LiquidAdditive = 6,
  SpacerDryBase = 7,
  SpacerDryFractionBase = 8,
  SpacerLiquidBase = 9,
  SpacerLiquidFractionBase = 10,
  SpacerDryAdditive = 11,
  SpacerLiquidAdditive = 12
}

interface MaterialTypeOption {
  label: string;
  value: MaterialTypes;
}

const MATERIAL_TYPE_OPTIONS: MaterialTypeOption[] = [
  { label: 'Dry Additive', value: MaterialTypes.Dry },
  { label: 'Liquid Additive', value: MaterialTypes.Liquid },
  { label: 'Cement', value: MaterialTypes.Cement },
  { label: 'Liquid Base', value: MaterialTypes.LiquidBase },
  { label: 'Poz', value: MaterialTypes.Pozolan },
  { label: 'Spacer Dry Base', value: MaterialTypes.SpacerDryBase },
  { label: 'Fraction Spacer Dry Base', value: MaterialTypes.SpacerDryFractionBase },
  { label: 'Spacer Liquid Base', value: MaterialTypes.SpacerLiquidBase },
  { label: 'Fraction Spacer Liquid Base', value: MaterialTypes.SpacerLiquidFractionBase }
];

export interface EditMaterialData {
  materialId: number;
  name: string;
  functionName: string;
  specificGravity: number | null;
  sackWeightLb: number | null;
  materialType: number;
  addAfterStirring: boolean;
  isActive: boolean;
  doNotRunFluidLossTestWithFoamers: boolean;
}

export interface EditMaterialResult {
  materialId: number;
  name: string;
  functionName: string;
  specificGravity: number | null;
  sackWeightLb: number | null;
  materialType: number;
  addAfterStirring: boolean;
  isActive: boolean;
  doNotRunFluidLossTestWithFoamers: boolean;
}

@Component({
  selector: 'app-edit-material-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule
  ],
  templateUrl: './edit-material-dialog.component.html',
  styleUrl: './edit-material-dialog.component.css',
})
export class EditMaterialDialogComponent {
  
  readonly materialTypeOptions = MATERIAL_TYPE_OPTIONS;

  data: EditMaterialData;
  originalMaterialName: string;

  constructor(
    public dialogRef: MatDialogRef<EditMaterialDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public inputData: EditMaterialData
  ) {
    this.data = { ...inputData };
    this.originalMaterialName = inputData.name;
  }

  get isValid(): boolean {
    return this.data.name.length > 0;
  }

  onSubmit(): void {
    if (!this.isValid) {
      return;
    }

    const result: EditMaterialResult = {
      materialId: this.data.materialId,
      name: this.data.name,
      functionName: this.data.functionName || '',
      specificGravity: this.data.specificGravity,
      sackWeightLb: this.data.sackWeightLb,
      materialType: this.data.materialType,
      addAfterStirring: this.data.addAfterStirring,
      isActive: this.data.isActive,
      doNotRunFluidLossTestWithFoamers: this.data.doNotRunFluidLossTestWithFoamers
    };

    this.dialogRef.close(result);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
